// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__NCUi2","inputWrap":"styles_inputWrap__1ZUWm","input":"styles_input__3kcYq"};